<template>
	<resource-list-item class="notification block" :class="{'hover:bg-gray-150': !!notification.url}" :image="notification.image" divided :avatar="imageAsAvatar"
						:image-ratio="imageRatio"
						:title="notification.title"
						:description="notification.text"
						:to="notification.url" :title-color="$config.public.colors.primary">

		<div class="flex items-center mt-12">
			<time class="text-xs text-gray-400">{{ $date(notification.created_at).fromNow() }}</time>
			<badge v-if="!notification.read_at" color="secondary" class="ml-8" top rounded-full x-small/>
		</div>

		<template #right>
			<form-btn :action="actionUrl" method="DELETE"
					  icon
					  text
					  rounded-full
					  x-small
					  @error="handleActionError"
					  @success="removeNotification" class="absolute right-0 top-0 m-4">
				<Icon :icon="icons.close" small color="gray-400" force-size/>
			</form-btn>
		</template>
	</resource-list-item>

</template>

<script>
import {ModelType} from "@spoferan/spoferan-ts-core";
import {checkIcon, closeIcon} from "../../config";

export default {

	name: 'Notification',

	emits: ['delete'],

	props: {
		notification: {
			type: Object,
			required: true
		},

		// The API EP where to modify the notification
		url: {
			type: String,
			default: null
		}
	},

	data() {
		return {
			icons: {
				close: closeIcon,
				check: checkIcon,
			}
		}
	},

	computed: {
		actionUrl() {
			return this.url ? this.url : ('/v1/notifications/' + this.notification.id)
		},

		imageAsAvatar() {
			return this.notification.trigger_type && this.notification.trigger_type === ModelType.User;
		},

		imageRatio() {
			return this.notification.trigger_type && this.notification.trigger_type === ModelType.Event ? 3 / 2 : 1;
		}
	},

	methods: {
		removeNotification() {
			this.$emit('delete');
		},

		handleActionError(status) {

			// Required for non existing notifications or requests
			if (status === 404) {
				this.removeNotification();
			}
		}
	}
}
</script>